// extracted by mini-css-extract-plugin
export default {"dropdownTitle":"SubHeader_dropdownTitle__jhNUM","tab":"SubHeader_tab__rAf17","subHeaderButtonDone":"SubHeader_subHeaderButtonDone__BWRNH","exportIcon":"SubHeader_exportIcon__HcgKF"};